export const getMicrosoftErrorMessage = (reason, fallbackMessage) => {
  if (fallbackMessage) return fallbackMessage;

  switch (reason) {
    case 'INTERACTION_REQUIRED':
      return 'La sessione Microsoft richiede una nuova autenticazione. Riprova ad effettuare l’accesso con Microsoft.';
    case 'BACKEND_JWT_MISSING':
      return 'Accesso Microsoft completato, ma il server non ha restituito il token applicativo.';
    case 'MISSING_ID_TOKEN':
      return 'Token Microsoft non disponibile.';
    case 'BACKEND_OAUTH_FAILED':
      return 'Autenticazione Microsoft fallita.';
    case 'COMPLETE_LOGIN_FAILED':
      return 'Errore durante il completamento dell’accesso Microsoft.';
    case 'HANDLE_REDIRECT_FAILED':
      return 'Errore durante la gestione del redirect Microsoft.';
    case 'NO_ACTIVE_ACCOUNT':
      return 'Account Microsoft non disponibile.';
    default:
      return 'Errore di autenticazione Microsoft.';
  }
};
